var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgInboxBell = function SvgInboxBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0013 18.125C10.9179 18.125 11.6679 17.375 11.6679 16.4583H8.3346C8.3346 17.375 9.07626 18.125 10.0013 18.125ZM15.0013 13.125V8.95833C15.0013 6.4 13.6346 4.25833 11.2513 3.69167V3.125C11.2513 2.43333 10.6929 1.875 10.0013 1.875C9.3096 1.875 8.75126 2.43333 8.75126 3.125V3.69167C6.3596 4.25833 5.00126 6.39167 5.00126 8.95833V13.125L3.92626 14.2C3.40126 14.725 3.76793 15.625 4.5096 15.625H15.4846C16.2263 15.625 16.6013 14.725 16.0763 14.2L15.0013 13.125Z",
    fill: "url(#paint0_linear_51852_20604)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_51852_20604",
    x1: 3.6792,
    y1: 3.87737,
    x2: 18.4303,
    y2: 12.5251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8461,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE27B"
  })))));
};
var Memo = /*#__PURE__*/memo(SvgInboxBell);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "_/_/packages/moonlight/lib/assets/icons/inbox-bell.f86933c344e0d08d6a35cc11bb856bdc.svg";